<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/accountancy')">Contabilidad</li>
        <li class="breadcrumb-item">Reportes regulatorios</li>
        <li class="breadcrumb-item active" aria-current="page">Consulta</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row justify-content-md-center" style="margin-top:20px;">
        <div class="col-md-12">
          <vs-card title="Historial de transacciones">
            <vs-table :data="consulta">
              <template slot='thead'>
                <vs-th>Id</vs-th>
                <vs-th>R. Id</vs-th>
                <vs-th>Tipo</vs-th>
                <vs-th>Info. Enviada</vs-th>
                <vs-th>Info. Recibida</vs-th>
                <vs-th>Fecha</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :key="index" v-for="(row, index) in data">
                  <vs-td>#{{ row.id }}</vs-td>
                  <vs-td>#{{ row.regulatory_report_id }}</vs-td>
                  <vs-td>{{ row.type }}</vs-td>
                  <vs-td>
                    <vs-button @click="openModal(row.regulatory_report_id,'sent')"
                               color="success">
                      {{ row.payload_sent.identificadorReporte.reporte }}
                    </vs-button>
                  </vs-td>
                  <vs-td>
                    <vs-button @click="openModal(row.regulatory_report_id,'received')">
                      {{ row.payload_received.folio == null ? 'Sin folio' : row.payload_received.folio }}
                    </vs-button>
                  </vs-td>
                  <vs-td>{{ row.created_at }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>


            <vs-popup :active.sync="modal.show" :title="modal.title">
              <div v-html="$sanitizeHtml(modal.content)"></div>
              <div class="mt-6">
                <vs-button color="dark" @click="closeModal">Cerrar</vs-button>
              </div>
            </vs-popup>


          </vs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import syntaxHighlight from "@mixins/syntaxHighlightJSON";

export default {
  name: 'consulta-reportes',
  mixins: [syntaxHighlight],
  data() {
    return {
      consulta: null,
      modal: {
        show: false,
        title: '',
        content: ''
      }
    };
  },
  mounted() {
    this.getConsultaReportes();
  },
  methods: {
    async getConsultaReportes() {
      this.$vs.loading();
      await axios.get(
          `/api/sitiapi/regulatoryReportsTracking`
      )
          .then(response => {
            this.consulta = response.data
            for (const index in response.data) {
              this.consulta[index].payload_sent = JSON.parse(response.data[index].payload_sent);
              this.consulta[index].payload_received = JSON.parse(response.data[index].payload_received);
            }
            return this.consulta;
          });
      this.$vs.loading.close();
    },
    openModal(id, type_payload) {
      let detail = this.consulta.find(row => row.regulatory_report_id == id);
      let detail_by_type = '';
      this.modal.show = true;
      this.modal.title = `Detalle ID#${id} | ${type_payload}`;
      switch (type_payload) {
        case 'sent':
          detail_by_type = detail.payload_sent;
          break;
        case 'received':
          detail_by_type = detail.payload_received;
          break;
      }
      this.modal.content = `${this.syntaxHighlight(detail_by_type)}`;
    },
    closeModal() {
      this.modal.show = false;
    },
  },
}
</script>
